import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'qaroni-label-text-preview',
  templateUrl: './label-text-preview.component.html',
  styleUrls: ['./label-text-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LabelTextPreviewComponent {
  readonly label = input<string>('');
  readonly value = input<string | number>('');
}
